import { render, staticRenderFns } from "./BioHighlightItem.vue?vue&type=template&id=33f3f7fa"
import script from "./BioHighlightItem.vue?vue&type=script&lang=js"
export * from "./BioHighlightItem.vue?vue&type=script&lang=js"
import style0 from "./BioHighlightItem.vue?vue&type=style&index=0&id=33f3f7fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports